import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, of, throwError } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { selectBffBaseUrl } from '../store/selectors/api-config.selectors';
import { selectStartPageUrl } from '../store/selectors/app-config.selectors';
import { selectOnboardingBaseUrl } from '../store/selectors/onboarding-config.selectors';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  constructor(private store: Store) {
    this.allowedOrigins$ = combineLatest([
      this.store.pipe(selectStartPageUrl),
      this.store.pipe(selectOnboardingBaseUrl),
      this.store.pipe(selectBffBaseUrl),
    ]).pipe(take(1));
  }

  private allowedOrigins$: Observable<string[]>;

  public isValidRedirectUrl(url: string): Observable<boolean> {
    if (url.startsWith('/') || url.startsWith(location.origin)) {
      return of(true);
    }

    return this.allowedOrigins$.pipe(
      map(
        (allowedOrigins) =>
          allowedOrigins.length &&
          allowedOrigins.some((origin) => url.startsWith(origin)),
      ),
    );
  }

  public redirectTo(url: string) {
    const redirect$ = this.isValidRedirectUrl(url).pipe(
      map((isValid) => {
        if (isValid) {
          return url;
        } else {
          throw new Error(
            `Could not redirect to ${url}. The provided url does not match any allowed origins.`,
          );
        }
      }),
    );

    redirect$.subscribe((url) => {
      if (url) {
        window.location.href = url;
      }
    });

    return redirect$;
  }
}
